export const API_ROUTES = {
  // common routes
  COMMON_FETCHCORDINATESDATA: "/signature/fetchCordinatesData",
  COMMON_HANDLESIGNREJECTION: "/signature/handleSignRejection",
  COMMON_EXTERNALUSER_DATA_CHECKORADD: "/signature/signer-profile/checkOrAdd",
  COMMON_EXTERNALUSER_SIGNATURE_FETCHALL:
    "/signature/signer-profile/fetchAll",
  COMMON_EXTERNALUSER_SIGNATURE_REMOVESIGNATURE:
    "/signature/removeSignature",
  COMMON_EXTERNALUSER_SIGNATURE_ADD: "/signature/add",
  COMMON_DOCUMENTS_INPERSONSIGNING_FETCHSIGNATORIES:
    "/common/documents/inPersonSigning/fetchSignatories",
  // COMMON_DOCUMENTS_INPERSONSIGNING_SAVESIGNATURE:
  //   "/common/documents/inPersonSigning/saveSignatures",
  COMMON_DOCUMENTS_INPERSONSIGNING_SAVESIGNATURE:
    "/signature/saveSignature",
  COMMON_DOCUMENTS_SELFSIGNING_FETCHSIGNATORIES:
    "/common/documents/selfSigning/fetchSignatories",
  COMMON_DOCUMENTS_SELFSIGNING_SAVESIGNATURE:
    "/common/documents/selfSigning/saveSignatures",
  // auth
  SENDOTP: "/sendOtp",
  CHECKSTATUS: "/signature/checkStatus",

  // audit
  AUDIT_TRACKDOCUMENTVIEWED: "/docSignAuditTrails/audit/trackDocumentViewed",
  AUDIT_FETCHAUDITTRAILS: "/docSignAuditTrails/fetchAuditTrails",

  // other
  // GEOLOLCATION: "https://geolocation-db.com/json/",
};

export const STATUS_CODE = {
  SUCCESS: 200,
  UNAPPROVED: 400,
  UNAUTHORIZED: 401,
  ERROR: 404,
};

export const RESPONSE_MSGS = {
  ERROR: "Something went wrong!",
  OTP_SENT: "OTP sent successfully!",
  OTP_VERIFIED: "OTP verified successfully!",
  LOGGED_IN: "LoggedIn successfully!",
  EMAIL_SENT: "Email sent successfully!",
  PASSWORD_CHANGED: "Password changed successfully!",
  AGREEMENT_UPLOAD_SUCCESS: "Successfully Imported!",
  AGREEMENT_UPLOAD_FAILED: "Importing Failed!",
  EXTRACTION_VALIDATE_SUCCESS: "Extraction validated successfully!",
  NO_RESULT_FOUND: "No Result Found",
  EXTRACTION_AGREEMENT_SUCCESS: "Extraction Agreement successfully!",
  NEW_AGREEMENT_SUCCESS: "Successfully Done!",
  AGREEMENT_REJECTED_STATUS: "Agreement Rejected",
  AGREEMENT_SHARED_STATUS: "Agreement shared successfully",
  AGREEMENT_SIGNED_STATUS: "Agreement signed successfully",
  VENDOR_CREATED_SUCCESS: "User created successfully",
  TOKEN_EXPIRED_AND_LOGIN_AGAIN: "Session Expired. Please login again.",
  EXTRACTION_DELETE_SUCCESS: "Document deleted successfully!",
};
